import styles from './FieldDescription.module.scss'
import iconInfo from '../../../../../../public/images/info-blue.svg'
import { IFieldDescriptionProps } from './types'

export const FieldDescription = ({ description }: IFieldDescriptionProps) => {
    return (
        <div className={styles.wrapper}>
            <img src={iconInfo} />
            <span>{description}</span>
        </div>
    )
}
